/* @generated */

// src/assets/ui-icon/line/metal.tsx
import * as React from "react";
var MetalLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.242 6.197a2.245 2.245 0 1 1 4.489 0v1.956a2.24 2.24 0 0 1 .745-.126c.577 0 1.103.217 1.5.575a2.237 2.237 0 0 1 2.247-.449V6.197a2.245 2.245 0 1 1 4.489 0v8.985a4.25 4.25 0 0 1-1.107 2.861l-1.825 2.004H7.639L5.83 16.986a4.25 4.25 0 0 1-.59-2.16V6.197Zm5.234 7.706c.577 0 1.103-.218 1.5-.576.245.22.538.387.862.483A3.141 3.141 0 0 0 11.643 16l-.044.477 1.493.137.044-.477a1.643 1.643 0 0 1 2.009-1.45l2.067.482v.013a2.75 2.75 0 0 1-.716 1.851l-1.378 1.514H8.494l-1.37-2.323a2.75 2.75 0 0 1-.382-1.398V6.197a.745.745 0 1 1 1.489 0v5.461a2.245 2.245 0 0 0 2.245 2.245Zm6.736-.274V6.197a.745.745 0 0 0-1.49 0v7.085l1.49.347Zm-2.99-1.967v-1.394a.745.745 0 0 0-1.49.003v1.387a.745.745 0 0 0 1.49.004Zm-4.491-1.39a.745.745 0 0 1 1.49 0v1.386a.745.745 0 0 1-1.49 0v-1.387Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  MetalLine
};
